import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getEvents = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `events`);
};
export const getTheEvent = (id: number) => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `events/one?id=` + id);
};
export const AddEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `events/create`, obj, {
    headers,
  });
};

export const EditEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `events/update`, obj, {
    headers,
  });
};

export const DeleteEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `events/delete`, obj, {
    headers,
  });
};
